// @flow
import * as React from 'react';

import type {
  AcmeUpdate as AcmeProductUpdate,
  DecoratedProduct,
} from '@gandi/cart';

import { useBestCatalogPrice } from '../modules/catalog';

import { AcmeProductItem } from './AcmeProductItem';
import TotalRow from './components/Rows/TotalRow';

type Props = { product: AcmeProductUpdate & DecoratedProduct };

export function AcmeUpdate({ product }: Props): React.MixedElement {
  const { priceCrossedOut, total } = useBestCatalogPrice(product.id);

  const footer = (
    <TotalRow priceCrossedOut={priceCrossedOut} totalPrice={total} />
  );

  return (
    <AcmeProductItem
      product={product}
      domains={product.payload.domains_to_add}
      footer={footer}
    />
  );
}
